import ArrowIcon from './ArrowIcon';

export default ArrowIcon;
